import UncorrectableErrorScreen from './UncorrectableErrorScreen';

export default UncorrectableErrorScreen;
